import {
  UPDATE_TASKSV3_FILTERS,
  RESET_TASKSV3_FILTERS,
} from 'actions';
import { DUE_DATE_LABELS, ROUTE_SEGMENTS } from 'src/pages/tasksV3/constants';

export const defaultRouteFilters = {
  statusFilter: ['to_do', 'overdue'],
  dateFilter: DUE_DATE_LABELS.THIS_WEEK,
  providerFilter: [],
  assigneeFilter: [],
  submittingOrgFilter: [],
  countyFilter: [],
  languageFilter: [],
  identifiedNeedsFilter: [],
  identifiedNeedsCountFilter: [],
  enhancedPopulationsFilter: [],
};

const createDefaultRouteFilters = () => ({
  ...defaultRouteFilters,
  statusFilter: [...defaultRouteFilters.statusFilter],
  providerFilter: [],
  assigneeFilter: [],
  submittingOrgFilter: [],
  countyFilter: [],
  languageFilter: [],
  identifiedNeedsFilter: [],
  identifiedNeedsCountFilter: [],
  enhancedPopulationsFilter: [],
});

export const defaultState = {
  filtersByRoute: {
    [ROUTE_SEGMENTS.ALL]: createDefaultRouteFilters(),
    [ROUTE_SEGMENTS.INBOUND_SCREENINGS]: createDefaultRouteFilters(),
    [ROUTE_SEGMENTS.USER_CREATED]: createDefaultRouteFilters(),
  },
};

function tasksV3Reducer(state = defaultState, action = {}) {
  switch (action.type) {
    case UPDATE_TASKSV3_FILTERS: {
      const routeKey = action.payload?.routeKey;
      if (!routeKey) {
        return state;
      }

      return {
        ...state,
        filtersByRoute: {
          ...state.filtersByRoute,
          [routeKey]: {
            ...createDefaultRouteFilters(),
            ...state.filtersByRoute?.[routeKey],
            ...action.payload.filters,
          },
        },
      };
    }
    case RESET_TASKSV3_FILTERS: {
      const routeKey = action.payload?.routeKey;
      if (!routeKey) {
        return state;
      }

      return {
        ...state,
        filtersByRoute: {
          ...state.filtersByRoute,
          [routeKey]: createDefaultRouteFilters(),
        },
      };
    }
    default:
      return state;
  }
}

export default tasksV3Reducer;
